import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const PRIMARY_ITEMS = [
  { path: '/', label: 'Ride', mark: 'Now' },
  { path: '/buses', label: 'Live route', mark: 'Map' },
  { path: '/analytics', label: 'Analysis', mark: 'Flow' },
];

const SECONDARY_ITEMS = [
  { path: '/about', label: 'About the data' },
  { path: '/donate', label: 'Support' },
];

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isActive = (path) => location.pathname === path || (path === '/' && location.pathname === '/stops');

  return (
    <>
      <header className="site-nav">
        <Link to="/" className="site-brand" aria-label="Magic Bus B61 ride view">
          <span className="route-badge">B61</span>
          <span className="site-brand__words">
            <strong>Magic Bus</strong>
            <small>Red Hook route intelligence</small>
          </span>
        </Link>

        <nav className="site-nav__links" aria-label="Primary navigation">
          {PRIMARY_ITEMS.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={isActive(item.path) ? 'is-active' : ''}
              aria-current={isActive(item.path) ? 'page' : undefined}
            >
              <small>{item.mark}</small>
              {item.label}
            </Link>
          ))}
        </nav>

        <button
          type="button"
          className="menu-button"
          onClick={() => setIsMenuOpen((open) => !open)}
          aria-label="Open more navigation"
          aria-expanded={isMenuOpen}
        >
          <span />
          <span />
        </button>

        {isMenuOpen && (
          <nav className="more-menu" aria-label="More navigation">
            {SECONDARY_ITEMS.map((item) => (
              <Link key={item.path} to={item.path} onClick={() => setIsMenuOpen(false)}>
                {item.label}
              </Link>
            ))}
          </nav>
        )}
      </header>

      <nav className="mobile-nav" aria-label="Mobile primary navigation">
        {PRIMARY_ITEMS.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={isActive(item.path) ? 'is-active' : ''}
            aria-current={isActive(item.path) ? 'page' : undefined}
          >
            <small>{item.mark}</small>
            {item.label}
          </Link>
        ))}
      </nav>
    </>
  );
};

export default Navigation;
